import React, { useEffect, useState } from 'react';
import { Tabs, Button, Table, Tag, Space, Card } from 'antd';
import { Link } from 'react-router-dom';
import Statuses from '../../modules/Status/Statuses';
import { RoleList } from '../Role/RoleList';
import DiscountRate from '../DiscountRate/DiscountRate';
import ToolList from '../../components/Tools/ToolList';
import ParameterList from '../../components/Parameters/ParameterList';
import OfferingList from '../../components/Offerings/OfferingList';
import ProposalListWithDetails from '../../components/ProjectFollowUp/ProposalList';
import ProposalList from '../../components/Proposal/ProposalList';

const { TabPane } = Tabs;

const Payments: React.FC = () => {
  // "proposal.show" iznini kontrol etmek için permissions state
  const [permissions, setPermissions] = useState<string[]>([]);
  const [activeKey, setActiveKey] = useState('1');
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const handleTabChange = (key: string) => {
    setActiveKey(key);
  };

  useEffect(() => {
    // permissions'ı localStorage'dan okuyup parse ediyoruz
    const storedPermissions = localStorage.getItem('permissions');
    if (storedPermissions) {
      try {
        const parsedPermissions = JSON.parse(storedPermissions);

        // Eğer JSON içeriği gerçekten bir array ise set et
        if (Array.isArray(parsedPermissions)) {
          setPermissions(parsedPermissions);
        } else {
          console.error('Permissions hatalı formatta:', parsedPermissions);
        }
      } catch (err) {
        console.error('Permissions parse hatası:', err);
      }
    }
    setIsLoading(false);
  }, []);

  return (
    <div className='mb-60px'>
      {isLoading ? (
        <div>Loading...</div>
      ) : permissions.includes('proposal.show') && (
        <>
          <Tabs
            activeKey={activeKey}
            onChange={handleTabChange}
            className="custom-tabs"
            tabBarStyle={{ borderBottom: 'none' }}
            destroyInactiveTabPane
          >
            <TabPane
              tab={
                <Button
                  type={activeKey === '1' ? 'primary' : 'default'}
                  className="d-button tab-button"
                >
                  Planlanmış Ödemeler
                </Button>
              }
              key="1"
            >
              <ProposalListWithDetails defaultStatusIds={[4]} type={5} paymentType={1} sortFieldProp={"invoiceDate"} sortDirectionProp={"ASC"} />
            </TabPane>
            <TabPane
              tab={
                <Button
                  type={activeKey === '2' ? 'primary' : 'default'}
                  className="d-button tab-button"
                >
                  Gerçekleştirilmiş Ödemeler
                </Button>
              }
              key="2"
            >
              <ProposalListWithDetails defaultStatusIds={[4]} type={5} paymentType={2} sortFieldProp={"paidDate"} sortDirectionProp={"DESC"} />
            </TabPane>
          </Tabs>
        </>
      )}
    </div>
  );
};

export default Payments;